import { render, staticRenderFns } from "./Copy&Paste.vue?vue&type=template&id=00c68c09&"
import script from "./Copy&Paste.vue?vue&type=script&lang=js&"
export * from "./Copy&Paste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00c68c09')) {
      api.createRecord('00c68c09', component.options)
    } else {
      api.reload('00c68c09', component.options)
    }
    module.hot.accept("./Copy&Paste.vue?vue&type=template&id=00c68c09&", function () {
      api.rerender('00c68c09', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/2.0/js/modules/Audience/Import/Components/Steps/Copy&Paste.vue"
export default component.exports